var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'configuration-card': true }},[_c('figure',{staticClass:"responsive-image"},[_vm._t("image")],2),_vm._v(" "),_c('div',{directives:[{name:"stack-y",rawName:"v-stack-y:sm",arg:"sm"}],staticClass:"content"},[_c('h3',[_vm._t("title")],2),_vm._v(" "),_vm._t("default"),_vm._v(" "),_vm._t("link")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }